<template>
  <section id="SectionBigBank" :class="background">
    <Wrap class="lg">
      <h3 class="title">
        {{ title || $t('title') }}
      </h3>

      <Splitter :left="7" :right="5">
        <div slot="left">
          <p>{{ $t('text') }}</p>

          <ul class="bulletpoints">
            <li v-for="(item, index) in $ta('bulletpoints')" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>

        <div slot="right">
          <BigBank />
        </div>
      </Splitter>
      <div class="cta">
        <Route class="Btn" :title="$t('cta')" :to="{ name: $route.name, hash: '#FooterContact' }">
          {{ $t('cta') }}
        </Route>
      </div>
    </Wrap>
  </section>
</template>

<script>
import BigBank from './BigBank'
import Splitter from './Splitter'

export default {
  components: {
    BigBank,
    Splitter,
  },
  props: {
    background: String,
    title: String,
  },
}
</script>

<style lang="scss">
#SectionBigBank {
  .title {
    margin-bottom: 3rem;
  }

  .bulletpoints {
    margin-top: 1.5rem;
    opacity: 0.8;
    padding-left: 1rem;
  }

  .cta {
    margin-top: 3rem;
    text-align: center;
    @include md {
      margin-top: 4rem;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Išskirtinės įsigijimo išsimokėtinai sąlygos",
    "text": "Bendradarbiaujame su BigBank, kad galėtume pasiūlyti palankiausias išsimokėjimo sąlygas. Patikėkite saulės elektrinės įrengimą Nogrid ir gausite turbūt geriausias išsimokėjimo sąlygas rinkoje:",
    "bulletpoints": [
      "metinės palūkanos tik 4,6%;",
      "sutarties sudarymo mokestis tik 1,9% (išmokamas lygiomis dalimis per visą paskolos grąžinimo laikotarpį);",
      "išsimokėjimo terminas nuo 36 mėn. iki 120 mėn.;",
      "nereikalinga pradinė įmoka;",
      "jokių baudų už anksčiau laiko grąžintą paskolos dalį;",
      "atsakymas dėl paskolos suteikimo per 2 val. darbo metu."
    ],
    "cta": "Sužinokite savo mėnesio įmoką "
  }
}
</i18n>
